export default __webpack_public_path__ + "static/media/warning--winding-road-first-left--g3.6e45aecc.png";